import {
  getNextSetupStage,
  setSetupStage,
  persistSetupStage
} from '../setup/setup-stage-manager.js';

import { canEdit } from '../app/auth-utils.js';

import { showLoginForm } from '../setup/auth/ui-login.js';
import { showMainContent } from '../app/ui-main.js';
import { initSettingsPanel } from '../settings/ui-settings-panel.js';

import { createProfilePanel } from '../setup/ui-setup-profile-create-panel.js';
import { createFoodPanel } from '../setup/ui-setup-food-create-panel.js';
import { quickCreatePetProfile, quickCreatePetFoods } from '../setup/quick-setup.js';
// import { isAlwaysFree } from '../feature-flags.js';
import { loadClientNicks } from '../requests/clients.js';
import { setNicks } from '../state-manager.js';
import { initializeFeatureFlags } from '../feature-flags.js';

export function startSetupUseCase() {
  console.log('[Setup] Starting first-time setup...');
  showLoginForm({ showRegister: true });
}

export function startSetupContinuation() {
  console.log('[Setup] Continuing setup after first login...');

  // Hide login
  document.getElementById('login-container')?.classList.add('hidden');

  continueSetupFlow();
}

function profileStageCompleted() {
  setSetupStage({ profilesCreated: true });
  persistSetupStage();
  continueSetupFlow(); // Decide next step (→ food, or → app)
}

function foodStageCompleted() {
  setSetupStage({ foodsCreated: true });
  persistSetupStage();
  continueSetupFlow(); // Decide next step (→ food, or → app)
}

export function continueSetupFlow() {

  if (!canEdit()) {
    console.log('[Setup] User cannot edit. Skipping setup flow.');
    loadApp(); // No setup needed, just load app
    return;
  }
  const stage = getNextSetupStage();

  if (stage === 'profiles') {
    console.log('[Setup] The profiles stage - Quick create profiles...');
    quickCreatePetProfile(profileStageCompleted);
    // if (isAlwaysFree()) {
    //   console.log('[Setup] The profiles stage - always free version. Quick create profiles...');
    //   quickCreatePetProfile(profileStageCompleted);
    // } else {
    //   console.log('[Setup] The profiles stage - Opening profile creation panel...');
    //   createProfilePanel.open();
    // }
  } else if (stage === 'foods') {
    console.log('[Setup] The foods stage - Quick create foods...');
    quickCreatePetFoods(foodStageCompleted); // Finalize setup
    // if (isAlwaysFree()) {
    //   console.log('[Setup] The foods stage - always free version. Quick create foods...');
    //   quickCreatePetFoods(foodStageCompleted); // Finalize setup
    // } else {
    //   console.log('[Setup] The foods stage - Opening food creation panel...');
    //   createFoodPanel.open();
    // }
  } else {
    console.log('[Setup] No further setup stages. Loading app...');
    loadApp(); // Setup complete
  }
}


export function startLoginUseCase() {
  console.log('[Login] Starting login flow...');
  showLoginForm({ showRegister: false });
}

export async function loadApp() {
  console.log('[App] Loading main interface...');

  // Hide setup & settings
  document.getElementById('setup-content')?.classList.add('hidden');
  document.getElementById('settings-panel')?.classList.add('hidden');

  // Show main content
  document.getElementById('main-content')?.classList.remove('hidden');
  // if (canEdit()) {
  document.getElementById('open-settings-btn')?.classList.remove('hidden');
  // }
  const nicks = await loadClientNicks();
  setNicks(nicks);
  
  await initializeFeatureFlags();
  showMainContent();
  // await initSettingsPanel();
}

createProfilePanel.onSubmitSuccess = () => {
  profileStageCompleted();
};

createFoodPanel.onSubmitSuccess = () => {
  foodStageCompleted(); // Finalize setup
};

